export { default } from './ErrorBoundary';
export { default as ErrorBoundary } from './ErrorBoundary';
